<template>
  <div>
    <div class="info-area">
      <h3 class="area-title">测试日期</h3>
      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">开始时间：</span>
          <DatePicker v-model:value="formData.startDate" placeholder="请选择开始时间" format="YYYY-MM-DD" value-format="YYYY-MM-DD" style="width: 200px;" />
        </div>
        <div class="info-item">
          <span class="info-label">有效期限：</span>
          <Select v-model:value="formData.months" placeholder="请选择有效期" style="width: 200px;">
            <Option v-for="option in validityPeriodOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </Option>
          </Select>
        </div>
      </div>
    </div>
    <div class="info-area">
      <h3 class="area-title">测试路线</h3>
      <Table
          :columns="testAreaColumns"
          :data-source="testAreaRoutes"
          :pagination="false">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'actions'">
              <span>
                <a-button style="padding: 0 5px"  class="action-btn" type="link" danger @click="$emit('delete-route', record.key)">删除</a-button>
              </span>
          </template>
        </template>
      </Table>
      <Button @click="$emit('add-route')" type="dashed" style="width: 100%; margin: 10px 0; padding: 8px 5px; font-size: 16px; text-align: center; line-height: 24px;">
        + 选择测试路线
      </Button>
    </div>
  </div>
</template>

<script setup>
import { Button, Select, DatePicker, Table } from 'ant-design-vue';

const { Option } = Select;

defineProps({
  formData: {
    type: Object,
    required: true
  },
  testAreaRoutes: {
    type: Array,
    default: () => []
  },
  validityPeriodOptions: {
    type: Array,
    default: () => [
      { value: 1, label: '1个月' },
      { value: 3, label: '3个月' },
      { value: 6, label: '6个月' }
    ]
  },
  testAreaColumns: {
    type: Array,
    default: () => [
      {
        title: '测试区域',
        dataIndex: 'areaName',
        key: 'areaName'
      },
      {
        title: '测试路线',
        dataIndex: 'routeName',
        key: 'routeName'
      },
      {
        title: '操作',
        dataIndex: 'actions',
        key: 'actions',
        width: 160
      }
    ]
  }
});

defineEmits(['add-route', 'delete-route']);
</script>

<style scoped lang="less">
.info-area {
  margin-bottom: 20px;
  padding: 10px 12px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
}

.area-title {
  margin-top: 0;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9d9d9;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.info-label {
  width: 100px;
  font-size: 15px;
  color: #666;
  flex-shrink: 0;
}
</style>